import { QueryClient, type DefaultOptions } from '@tanstack/react-query';

/** Options a caller (tests) may override; everything else keeps the app's real behaviour. */
export interface QueryClientOverrides {
  retry?: false;
  gcTime?: number;
}

/**
 * Builds the app's QueryClient. Failed queries are NOT thrown to the ErrorBoundary: each section renders its own
 * error state with Retry. The boundary stays for render errors only.
 */
export function createQueryClient(overrides: QueryClientOverrides = {}): QueryClient {
  const queries: NonNullable<DefaultOptions['queries']> = {
    staleTime: 30_000, // 30 seconds
    retry: 1,
    refetchOnWindowFocus: false,
    ...overrides,
  };
  return new QueryClient({ defaultOptions: { queries } });
}

export const queryClient = createQueryClient();
